module.exports = __webpack_public_path__ + "img/p2.48290734.png";